import { useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import type { SiteId, AssetCameraKey } from "@visioni/a3s-schema";
import { openGateMutation } from "./commands";
import type { CommandBody } from "../client-messages/commands";

export function useOpenGate() {
  const apiConfig = useApiConfig();

  const mutationConfig = useMemo(
    () =>
      apiConfig.tenant ?
        {
          tenantId: apiConfig.tenant.tenantId,
          apiBaseUrl: apiConfig.tenant.apiBaseUrl,
          authenticatedFetch: apiConfig.authenticatedFetch,
        }
      : { authenticatedFetch: apiConfig.authenticatedFetch },
    [apiConfig.tenant, apiConfig.authenticatedFetch],
  );

  return useMutation({
    mutationFn: ({ siteId, cameraKey }: { siteId: string; cameraKey: string }) => {
      const { mutationFn } = openGateMutation(mutationConfig, {
        siteId: siteId as SiteId,
        assetCameraKey: cameraKey as AssetCameraKey,
      });
      return mutationFn({ action: "open" } satisfies CommandBody);
    },
  });
}
